<template>
  <section>
    <transition name="modal">
      <div :class="['modal', diyClass, {'modal-absolute': positionAbsolute}]" v-show="show">
        <div class="modal-dialog diy-modal-position" :style="{'width': `${width}`, 'height': `${height}`, 'top': `${top}`}">
          <div class="modal-content">
            <div class="modal-close">
              <i class="c-close" @click="modalClose"></i>
            </div>
            <div v-show="title" class="modal-header">
              <div class="modal-title" v-html="title"></div>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal-shadow">
      <div class="modal-backdrop" v-show="show"></div>
    </transition>
  </section>
</template>

<script>
/**
 * 模态框组件
 * <cm-modal-simple :show="true" @close="functionName">html</cm-modal-simple>
 * :show:               是否显示模态框  bool     {true | false}  必选
 * :width:              模态框的宽度    string   {px | %}        可选，默认 50%
 * :height:             模态框的高度    string   {px | %}        可选，默认为内容高度
 * :diy-class           自定义class名   string   {modal-name}    可选
 * :position-absolute:  定位模式        bool     {true | false}  可选，默认 false
 * :top:                模态框的TOP     number   {}              开启绝对定位后必选
 * :title:              模态框的标题    string   {可使用HTML}     可选，默认 空
 * @close:              点击关闭事件    function                 必选
 */
export default {
  name: 'CmModalSimple',

  props: ['show', 'title', 'position-absolute', 'top', 'width', 'height', 'diy-class'],
  updated () {
    if (this.positionAbsolute) {
      return false
    }
    if (this.diyClass) {
      // 适应屏幕垂直居中
      let domBody = document.getElementsByClassName(this.diyClass)[0]
      let domModal = domBody.getElementsByClassName('diy-modal-position')[0]
      let bodyHeight = domBody.offsetHeight
      let modalHeight = domModal.offsetHeight
      domModal.style.top = `${bodyHeight / 2 - modalHeight / 2}px`
    }
  },
  methods: {
    modalClose () {
      this.$emit('close')
    }
  },
  watch: {
    show (val) {
      if (val) {
        document.getElementsByClassName('el-main')[0].style.overflow = 'hidden'
      } else {
        document.getElementsByClassName('el-main')[0].style.overflow = 'auto'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @bg-dark-gray: #606266;
  @font-dark-gray: #303133;
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    overflow: visible;
    -webkit-overflow-scrolling: touch;
    outline: 0;
    &--abs {
      position: absolute;
    }
  }

  .modal-close {
    @closeWH: 25px;
    @left: 10px;
    text-align: right;
    padding: @left @left 0 0;
    z-index: 1;
    // 关闭按钮
    .c-close {
      cursor: pointer;
      display: inline-block;
      height:  @closeWH;
      width:  @closeWH;
      text-align: right;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: @left;
        height:  @closeWH;
        width: 2px;
        background-color: @bg-dark-gray;
        transform: rotate(40deg);
      }
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: @left;
        height:  @closeWH;
        width: 2px;
        background-color: @bg-dark-gray;
        transform: rotate(-40deg);
      }
    }
  }

  .modal-absolute {
    position: absolute;
  }

  .modal-dialog {
    position: relative;
    width: 50%;
    margin: 0 auto;
  }

  .modal-content {
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 0 !important;
    outline: 0;
    box-shadow: 0 3px 9px rgba(0, 0, 0, .5);

    .fa {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 9;
    }
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000;
    opacity: .5;
  }

  .modal-header {
    min-height: 16.42857143px;
    padding: 10px 15px 15px;
    border-bottom: 1px solid #e5e5e5;
  }

  .modal-title {
    margin: 0;
    line-height: 1.42857143;
  }
  .modal-body {
    position: relative;
    padding: 0 15px 15px;
    overflow: hidden;
  }
  .modal-footer {
    padding: 15px;
    text-align: right;

    &_cancel {
      margin-left: 10px;
      color: @font-dark-gray;
      text-decoration: underline;
      font-size: 12px;
    }
  }

  // 模态框动画效果
  .modal-enter-active, .modal-enter-leave-active {
    transition: all .3s ease-out;
    transform: translate(0,0);
    opacity: 1;
  }
  .modal-enter, .modal-leave-to {
    transition: all .3s ease-out;
    transform: translate(0,-5%);
    opacity: 0;
  }

  // 模态框蒙层动画效果
  .modal-shadow-enter-active, .modal-shadow-enter-leave-active {
    transition: all .5s;
  }

  .modal-shadow-enter, .modal-shadow-leave-to {
    transition: all .5s;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// modalSimple.vue?d5516e8c